export const initialEnrollmentState = {
  selectedObjects: [],
  listId: undefined,
  filterBranch: undefined,
  shouldEnrollExistingFromListTriggers: undefined,
  hasCustomFilters: false,
  useRefinementFilters: false
};